__turbopack_context__.v({
  "blue": "LookUpRequestView-module-scss-module__RFMS9q__blue",
  "content0": "LookUpRequestView-module-scss-module__RFMS9q__content0",
  "content1": "LookUpRequestView-module-scss-module__RFMS9q__content1",
  "content2": "LookUpRequestView-module-scss-module__RFMS9q__content2",
  "cornflower": "LookUpRequestView-module-scss-module__RFMS9q__cornflower",
  "cyan": "LookUpRequestView-module-scss-module__RFMS9q__cyan",
  "fade_in_up": "LookUpRequestView-module-scss-module__RFMS9q__fade_in_up",
  "fade_out": "LookUpRequestView-module-scss-module__RFMS9q__fade_out",
  "green": "LookUpRequestView-module-scss-module__RFMS9q__green",
  "olive": "LookUpRequestView-module-scss-module__RFMS9q__olive",
  "orange": "LookUpRequestView-module-scss-module__RFMS9q__orange",
  "pink": "LookUpRequestView-module-scss-module__RFMS9q__pink",
  "review_image_border": "LookUpRequestView-module-scss-module__RFMS9q__review_image_border",
  "review_quotes_icon": "LookUpRequestView-module-scss-module__RFMS9q__review_quotes_icon",
});
